import type { BackpackRound } from "./backpack.ts";

export const NOTANY_BACKPACK_DECK_EL: readonly BackpackRound[] = [
  {
    goal: "Συσκευάστε αυτό που πραγματικά χρειάζεστε για να ξεκινήσετε μια εσωτερική εκπαίδευση στο notanyai.",
    chips: [
      {
        text: "Το δικό σας SubjectPack (το περιεχόμενό σας).",
        belongsInPrompt: true,
        conceptId: "your_content",
      },
      {
        text: "Ο προσαρμοστικός κινητήρας.",
        belongsInPrompt: true,
        conceptId: "adaptive_core",
      },
      {
        text: "Ο δικός σας λογαριασμός cloud ή VPC.",
        belongsInPrompt: true,
        conceptId: "self_hosted",
      },
      {
        text: "Άδεια SaaS ανά θέση.",
        belongsInPrompt: false,
        conceptId: "open_no_lockin",
      },
      {
        text: "Μια συμφωνία για την αποστολή των δεδομένων σας σε τρίτο μέρος.",
        belongsInPrompt: false,
        conceptId: "self_hosted",
      },
    ],
  },
  {
    goal: "Καταγράψτε τι αποδεικνύει την ικανότητα στο τέλος ενός μαθήματος.",
    chips: [
      {
        text: "Επίτευξη ανά έννοια για κάθε άτομο.",
        belongsInPrompt: true,
        conceptId: "measured_proof",
      },
      {
        text: "Ένα ελεγχόμενο αρχείο που μπορείτε να ρωτήσετε.",
        belongsInPrompt: true,
        conceptId: "measured_proof",
      },
      {
        text: "Στοιχεία που επιβιώνουν από έλεγχο.",
        belongsInPrompt: true,
        conceptId: "measured_proof",
      },
      {
        text: "Μια καταμέτρηση του πόσα βίντεο παίχτηκαν.",
        belongsInPrompt: false,
        conceptId: "measured_proof",
      },
    ],
  },
  {
    goal: "Αποφασίστε τι ισχύει για την προσαρμοστική βαθμολογία επιλογής.",
    chips: [
      {
        text: "Βαθμολογία Elo κάθε μαθητή.",
        belongsInPrompt: true,
        conceptId: "adaptive_core",
      },
      {
        text: "Κεντρικότητα προγράμματος σπουδών-γραφήματος (PageRank, interness).",
        belongsInPrompt: true,
        conceptId: "adaptive_core",
      },
      {
        text: "Κυριαρχία ανά έννοια, που διαδίδεται κατά μήκος του γραφήματος.",
        belongsInPrompt: true,
        conceptId: "adaptive_core",
      },
      {
        text: "Μια ανατροπή νομίσματος.",
        belongsInPrompt: false,
        conceptId: "adaptive_core",
      },
    ],
  },
  {
    goal: "Επιλέξτε τα θέματα που μια εταιρεία θα μπορούσε να στείλει στον ίδιο κινητήρα.",
    chips: [
      {
        text: "Ασκήσεις ασφάλειας και συμμόρφωσης.",
        belongsInPrompt: true,
        conceptId: "your_content",
      },
      {
        text: "Ενσωμάτωση νέας πρόσληψης.",
        belongsInPrompt: true,
        conceptId: "your_content",
      },
      {
        text: "Γνώση προϊόντων για ομάδες υποστήριξης.",
        belongsInPrompt: true,
        conceptId: "your_content",
      },
      {
        text: "Μόνο το μάθημα τεχνητής νοημοσύνης, τίποτα άλλο.",
        belongsInPrompt: false,
        conceptId: "your_content",
      },
    ],
  },
  {
    goal: "Συσκευάστε τα κομμάτια μιας αυτο-φιλοξενούμενης ανάπτυξης.",
    chips: [
      {
        text: "Ένα στατικό μπροστινό πακέτο.",
        belongsInPrompt: true,
        conceptId: "self_hosted",
      },
      {
        text: "Ένα ανοιχτό backend του Supabase.",
        belongsInPrompt: true,
        conceptId: "open_no_lockin",
      },
      {
        text: "Ένα μικρό VM.",
        belongsInPrompt: true,
        conceptId: "open_no_lockin",
      },
      {
        text: "Ένας υποχρεωτικός επεξεργαστής δεδομένων τρίτου μέρους.",
        belongsInPrompt: false,
        conceptId: "self_hosted",
      },
    ],
  },
  {
    goal: "Τι κάνει έναν μαθητή να επιστρέφει μέρα με τη μέρα;",
    chips: [
      {
        text: "Ένα καθημερινό σερί.",
        belongsInPrompt: true,
        conceptId: "adaptive_core",
      },
      {
        text: "Μίνι-παιχνίδια πέρα ​​από τα απλά κουίζ.",
        belongsInPrompt: true,
        conceptId: "adaptive_core",
      },
      {
        text: "Ένα μονοπάτι αναζήτησης με σαφή επόμενα βήματα.",
        belongsInPrompt: true,
        conceptId: "adaptive_core",
      },
      {
        text: "Αναδυόμενες διαφημίσεις μεταξύ ερωτήσεων.",
        belongsInPrompt: false,
        conceptId: "adaptive_core",
      },
    ],
  },
] as const;
